<template>
    <app-layout ref="lo" title="Dashboard">
        <template #header>
            <BreadCrumb :breadcrumb="$page.props.bc" />
        </template>

        <div class="py-4">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg">
                    <section class="text-gray-600 body-font">
                        <div class="container px-5 py-12 mx-auto">
                            <div class="flex flex-wrap w-full mb-5 flex-col">
                                <UserForm
                                    @loadData="loadEzData"
                                    @changeData="changeUserList"
                                    :selectedData="selected_user"
                                    ref="userForm"
                                ></UserForm>
                            </div>
                            <div class="flex flex-wrap w-full mb-5 flex-col">
                                <Toolbar>
                                    <template #start>
                                        <ButtonAdd
                                            label="Tambah"
                                            @click="tambah($event)"
                                            class="mr-1"
                                        />
                                        <ButtonDelete
                                            :disabled="
                                                selected_user.length == 0
                                            "
                                            label="Hapus"
                                            @click="hapus($event)"
                                            class="mr-1"
                                        />
                                        <ButtonEdit
                                            :disabled="
                                                selected_user.length != 1
                                            "
                                            label="Edit"
                                            @click="edit($event)"
                                            class="mr-1"
                                        />
                                        <ButtonReset
                                            label="Reset Password"
                                            class="mr-1"
                                            :disabled="
                                                selected_user.length != 1
                                            "
                                            @click="resetPassword($event)"
                                        />
                                    </template>

                                    <template #end> </template>
                                </Toolbar>
                            </div>
                            <div class="w-full mb-20">
                                <EzDataTable
                                    ref="ezdt"
                                    :config="ezdtConfig"
                                    @getSelectedData="getSelectedUser"
                                />
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </app-layout>
</template>

<script>
import { defineComponent } from "vue";
import AppLayout from "@/Layouts/AppLayout";
import BreadCrumb from "@/Components/BreadCrumb";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import Toolbar from "primevue/toolbar";
import ButtonAdd from "@/Components/ButtonAdd";
import ButtonDelete from "@/Components/ButtonDelete";
import ButtonEdit from "@/Components/ButtonEdit";
import InputText from "primevue/inputtext";
import UserForm from "@/Pages/User/Partials/UserForm";
import EzDataTable from "@/Components/EzDataTable";
import ButtonReset from "@/Components/ButtonReset";

import { Pesan } from "@/constants";

export default defineComponent({
    components: {
        Toolbar,
        InputText,
        AppLayout,
        BreadCrumb,
        ButtonAdd,
        ButtonDelete,
        ButtonEdit,
        UserForm,
        EzDataTable,
        ButtonReset,
    },
    data() {
        return {
            ezdtConfig: {
                dtHeader: "User",
                globalFilter: ["username"],
                defineCols: [
                    {
                        field: "username",
                        header: "Username",
                        style: "min-width: 15rem",
                        isFrozen: true,
                        col_type: "text",
                    },
                    {
                        field: "fullname",
                        header: "Nama Lengkap",
                        style: "min-width: 20rem",
                        col_type: "text",
                    },
                    {
                        field: "identity",
                        header: "Identity",
                        style: "min-width: 15rem",
                        col_type: "text",
                    },
                    {
                        field: "roles",
                        header: "Role",
                        style: "min-width: 20rem",
                        col_type: "html",
                        isSortAble: false,
                        isFilterAble: false,
                        col_body: function(data) {
                            if (!data.roles || !data.roles.length) return '';
                            
                            let html = '';
                            data.roles.forEach(role => {
                                let displayText = `<b>${role.name}</b>`;
                                
                                // Add unit name for specific roles if available
                                if ((role.name === 'oprpengadaan' || role.name === 'verifikatorpa') && 
                                    role.pivot && role.pivot.unit_id) {
                                    // Try multiple sources for the unit name
                                    const unitName = role.pivot.nama_unit || role.pivot.unit_name || role.unit_name;
                                    
                                    if (unitName) {
                                        displayText += ` (${unitName})</br>`;
                                    } else {
                                        displayText += ` (Unit: ${role.pivot.unit_id})`;
                                    }
                                }
                                
                                html += `<span class="badge badge-success mr-1">${displayText}</span>`;
                            });
                            
                            return html;
                        }
                    },
                    {
                        field: "created_at",
                        header: "Created At",
                        style: "min-width: 15rem",
                        col_type: "date",
                    },
                ],
                dtSourceApiRoute: {
                    list: "user.data",
                    drop: "user.bulkdelete",
                },
            },
            selected_user: [],
        };
    },
    methods: {
        changeUserList: function (data) {
            this.$refs.ezdt.changeDataSourceList(data);
            this.$refs.ezdt.loadData();
        },
        
        loadEzData: function () {
            this.$refs.ezdt.loadData();
        },
        
        getSelectedUser: function (data) {
            this.selected_user = data;
        },
        tambah: function (event) {
            this.selected_user = [];
            this.$refs.ezdt.resetSelection();
        },
        edit: function (event) {
            this.$refs.userForm.populateEdit(this.selected_user[0]);
        },
        hapus: function (event) {
            this.$confirm.require({
                target: event.currentTarget,
                message:
                    "Delete (" +
                    this.selected_user.length +
                    ") selected record ?",
                icon: "pi pi-info-circle",
                acceptClass: "p-button-danger",
                accept: () => {
                    let ids = [];
                    this.selected_user.forEach(function (item, index) {
                        ids.push(item.id);
                    });

                    this.$refs.ezdt.dropData(ids);
                },
                reject: () => {
                    //
                },
            });
        },
        resetPassword: function (event) {
            let self = this;
            self.$confirm.require({
                target: event.currentTarget,
                message: "Yakin akan melakukan reset ?",
                icon: "pi pi-info-circle",
                acceptClass: "p-button-danger",
                accept: () => {
                    axios
                        .post(route("user.resetpassword"), {
                            id: self.selected_user[0].id,
                        })
                        .then((res) => {
                            if (res.data.stts == Pesan.OK.STTS) {
                                self.$refs.lo.showToastOk();
                            }
                        })
                        .catch(function (error) {
                            //
                        })
                        .then(function () {
                            //
                        });
                },
                reject: () => {
                    //callback to execute when user rejects the action
                },
            });
        },
    },
});
</script>
